module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-8e4056c0.png";